// extracted by mini-css-extract-plugin
export default {"maincontainer":"editcard_maincontainer__VWyKi","icontitle":"editcard_icontitle__FNVlu","detailss":"editcard_detailss__9zXZe"};